import React from "react";

const Footer = () => {
  return(
  <footer className="text-center py-4 bg-primary">
    <p className="text-sm">
      &copy; {new Date().getFullYear()} Sapna Fashion. All rights reserved.
    </p>
  </footer>
  )
};

export default Footer;
